import React from 'react';

export const DataDeletion: React.FC = () => {
  return (
    <div className="legal-page pt-32 md:pt-36 pb-24 bg-[#f6f8f7]">
      <div className="container mx-auto px-4 max-w-4xl">
        <p className="text-sm font-bold text-[#087064] uppercase tracking-[0.2em] mb-4">Ancora Automations</p>
        <h1 className="legal-page__title text-4xl md:text-5xl text-[#10232d] mb-4">Eliminación de datos</h1>
        <p className="text-[#536970] mb-6">Última actualización: 18 de junio de 2026</p>
        <p className="text-[#536970] mb-12 rounded-2xl border border-[#b9d8d0] bg-[#dceee9] p-5">
          Esta página explica cómo solicitar la eliminación de datos personales tratados por Ancora Automations en su web y en aplicaciones conectadas a Meta, WhatsApp e Instagram.
        </p>
        <div className="prose prose-slate max-w-none">
          <section className="py-8 border-t border-[#d7e4e2]">
            <h2 className="text-xl font-bold text-[#10232d] mb-4">1. Cómo solicitar la eliminación</h2>
            <p className="text-[#536970]">
              Envía un email a <a href="mailto:automatiza@ancoraautomations.es" className="font-bold text-[#087064] underline">automatiza@ancoraautomations.es</a> con el asunto <strong>“Solicitud de eliminación de datos”</strong> e incluye, cuando sea posible:
            </p>
            <ul className="list-disc pl-6 mb-4 space-y-1 text-[#536970]">
              <li>Nombre completo o nombre de la empresa.</li>
              <li>Email o teléfono asociado a la conversación o servicio.</li>
              <li>Canal afectado: web, WhatsApp, Instagram, Facebook, email u otro.</li>
              <li>Descripción breve de los datos que quieres eliminar.</li>
            </ul>
          </section>

          <section className="py-8 border-t border-[#d7e4e2]">
            <h2 className="text-xl font-bold text-[#10232d] mb-4">2. Verificación de identidad</h2>
            <p className="text-[#536970]">
              Para proteger tu privacidad, podemos pedir información adicional razonable para confirmar que la solicitud procede de la persona titular de los datos o de una persona autorizada.
            </p>
          </section>

          <section className="py-8 border-t border-[#d7e4e2]">
            <h2 className="text-xl font-bold text-[#10232d] mb-4">3. Plazo de respuesta</h2>
            <p className="text-[#536970]">
              Revisaremos la solicitud y responderemos en un plazo máximo de 30 días, salvo que la normativa aplicable permita o exija un plazo distinto.
            </p>
          </section>

          <section className="py-8 border-t border-[#d7e4e2]">
            <h2 className="text-xl font-bold text-[#10232d] mb-4">4. Alcance de la eliminación</h2>
            <p className="text-[#536970]">
              Eliminaremos o anonimizaremos los datos personales cuando ya no sean necesarios para prestar el servicio, cumplir obligaciones legales, resolver incidencias, proteger la seguridad o mantener registros mínimos exigibles. Si algún dato no puede eliminarse de inmediato por obligación legal o técnica, te informaremos del motivo.
            </p>
          </section>

          <section className="py-8 border-t border-[#d7e4e2]">
            <h2 className="text-xl font-bold text-[#10232d] mb-4">5. Política de privacidad</h2>
            <p className="text-[#536970]">
              Puedes consultar la política completa en <a href="https://www.ancoraautomations.es/politica-privacidad.html" className="break-all font-bold text-[#087064] underline">https://www.ancoraautomations.es/politica-privacidad.html</a>.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};
